import { Button, Form } from 'antd';
import dayjs from 'dayjs';
import { useCreatePriceCategory } from 'features/events/use-cases/create-price-category';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { payFormatDate } from 'utils/payload-date-';

import { AddPriceCategoryForm } from './add-price-category-form';
import { PriceCategoryFormField, PriceCategoryFormValues } from './types';

export const AddPriceCategoryModal = ({ onClose, editId, data, getEventDetaildata }: { onClose: () => void; showAddPriceModal: boolean; editId: any, getEventDetaildata: any, refetch: () => void; data: any }) => {
    const { id } = useParams();
    const eventId = id;
    const formName = 'add-price-category-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<PriceCategoryFormValues>();
    const { isLoading, mutate } = useCreatePriceCategory(editId?.Id);

    const [selectedSeats, setSelectedSeats] = useState<number[]>([]);

    const layoutData = JSON.parse(localStorage.getItem("event_details") || "{}");

    const countStartSeat = layoutData?.startSeatNumber || 1;
    const countEndSeat = process.env.REACT_APP_SUFFIX_Ticket_IDS
        ? 35
        : layoutData?.endSeatNumber || 32;
    // const countEndSeat = layoutData?.endSeatNumber || 32;
    const layoutType = layoutData?.Category || "Normal";

    const bookedSeat = data?.reduce((acc: number[], item: any) => {
        if (item?.SeatNumber) {
            try {
                const seatNumbers = JSON.parse(item?.SeatNumber);

                return acc.concat(seatNumbers);
            } catch (error) {
                console.error("Error parsing SeatNumber:", error);
            }
        }

        return acc;
    }, []);



    const canUpdateSeat = editId?.SeatNumber ? JSON.parse(editId?.SeatNumber) : [];

    const seatArray = Array.from(
        { length: countEndSeat - countStartSeat + 1 },
        (_, i) => countStartSeat + i
    );

    // Filter out booked seats unless they are in canUpdateSeat
    const filteredSeatArray = seatArray?.filter(
        seat =>
            !bookedSeat?.includes(seat) || canUpdateSeat?.includes(seat)
    );


    const handleClose = () => {
        const registrationType = form.getFieldValue(PriceCategoryFormField.RegistrationType);

        onClose();
        setSelectedSeats([]);

        form.resetFields(); // reset all
        form.setFieldsValue({
            RegistrationType: registrationType, // restore
        });
    };
    const getInitialValues = {
        [PriceCategoryFormField.Id]: undefined,
        [PriceCategoryFormField.EventId]: undefined,
        [PriceCategoryFormField.Category]: undefined,
        [PriceCategoryFormField.CategoryAr]: undefined,
        [PriceCategoryFormField.Description]: undefined,
        [PriceCategoryFormField.DateFrom]: undefined,
        [PriceCategoryFormField.DateTo]: undefined,
        [PriceCategoryFormField.NoOfPersons]: undefined,
        [PriceCategoryFormField.RegistrationType]: undefined,
        [PriceCategoryFormField.GenderType]: undefined,
        [PriceCategoryFormField.StartNumber]: undefined,
        [PriceCategoryFormField.EndNumber]: undefined,
        [PriceCategoryFormField.Utilization]: undefined,
        [PriceCategoryFormField.AgeFrom]: undefined,
        [PriceCategoryFormField.AgeTo]: undefined,
        [PriceCategoryFormField.CategoryId]: undefined,
        [PriceCategoryFormField.IsRefundable]: false,
        [PriceCategoryFormField.Refund_desc]: undefined,
        [PriceCategoryFormField.Refund_price]: undefined,
        [PriceCategoryFormField.IsDelivarable]: false,
        [PriceCategoryFormField.Delivery_desc]: undefined,
        [PriceCategoryFormField.Delivery_price]: undefined,
        [PriceCategoryFormField.MinPI]: 1,
        [PriceCategoryFormField.MinPT]: undefined,
        [PriceCategoryFormField.MaxPI]: undefined,
        [PriceCategoryFormField.MaxPT]: undefined,
        [PriceCategoryFormField.PriceIn]: undefined,
        [PriceCategoryFormField.PriceTe]: undefined,
        [PriceCategoryFormField.PriceType]: undefined,
        [PriceCategoryFormField.Status]: true,
        [PriceCategoryFormField.IsWaiting]: false,
        [PriceCategoryFormField.TotalWaiting]: undefined,
        [PriceCategoryFormField.RegistEndDate]: undefined,
        [PriceCategoryFormField.RegistStartDate]: undefined,
        [PriceCategoryFormField.IsHiddenFromGroup]: false,
        [PriceCategoryFormField.ShowTicketLayout]: false,
    };


    const handleUpdate = (formData: PriceCategoryFormValues) => {
        // if (layoutType === "Layout" && !selectedSeats.length) return message.error("Please select at least one seat number.");

        formData[PriceCategoryFormField.Id] = editId?.Id;
        formData[PriceCategoryFormField.EventId] = eventId;
        formData[PriceCategoryFormField.Refund_price] = formData.Refundable_charge ?? 0;
        formData[PriceCategoryFormField.Refund_desc] = formData.Refundable_description ?? "";
        formData[PriceCategoryFormField.Delivery_price] = formData.Delivery_charge ?? 0;
        formData[PriceCategoryFormField.Delivery_desc] = formData.Delivery_description ?? "";
        if (editId) formData[PriceCategoryFormField.PriceType] = editId.Price_type;
        formData[PriceCategoryFormField.Status] = true;
        formData[PriceCategoryFormField.RegistStartDate] = formData.WaitingStartDate && payFormatDate(formData.WaitingStartDate);
        formData[PriceCategoryFormField.RegistEndDate] = formData.WaitingEndDate && payFormatDate(formData.WaitingEndDate);

        formData[PriceCategoryFormField.DateFrom] = formData.Date_from && payFormatDate(formData.Date_from);
        formData[PriceCategoryFormField.DateTo] = formData.Date_to && payFormatDate(formData.Date_to);
        // formData[PriceCategoryFormField.TotalWaiting] = +formData.WaitingParticipant;
        formData[PriceCategoryFormField.IsWaiting] = formData.IsWaiting ? formData.IsWaiting : false;
        formData[PriceCategoryFormField.IsHiddenFromGroup] = formData.IsHiddenFromGroup ? formData.IsHiddenFromGroup : false;
        formData[PriceCategoryFormField.ShowTicketLayout] = formData.ShowTicketLayout ? formData.ShowTicketLayout : false;
        formData[PriceCategoryFormField.SeatNumber] = selectedSeats.length > 0 ? JSON.stringify(selectedSeats) : "";
        mutate(formData, { onSuccess: handleSuccess });

    };


    const handleSuccess = () => {
        handleClose();
        // refetch()
    }
    const isNormalLayout = layoutType === "Normal";
    const isEventTicketing = getEventDetaildata?.events_ticketing;
    useEffect(() => {
    const shouldForceRegistrationType =
        layoutType === "Layout" ||
        (isNormalLayout && isEventTicketing);

    if (editId) {
        form.setFieldsValue({
            ...editId,
            WaitingStartDate: editId?.WaitingStartDate
                ? dayjs(editId.WaitingStartDate)
                : null,
            WaitingEndDate: editId?.WaitingEndDate
                ? dayjs(editId.WaitingEndDate)
                : null,
            Date_from: editId?.Date_from
                ? dayjs(editId.Date_from)
                : null,
            Date_to: editId?.Date_to
                ? dayjs(editId.Date_to)
                : null,
            RegistrationType: shouldForceRegistrationType
                ? 1
                : editId?.RegistrationType ?? undefined,
        });

        setSelectedSeats(
            editId?.SeatNumber ? JSON.parse(editId.SeatNumber) : []
        );
    } else {
        if (shouldForceRegistrationType) {
            form.setFieldsValue({ RegistrationType: 1 });
        } else {
            // Clear value when Normal only
            form.setFieldsValue({ RegistrationType: undefined });
        }
    }
}, [editId, layoutType, getEventDetaildata]);

    return (
        <>

            {
                <>
                    <div className='popup'>
                        <div className='modal_head'>
                            <h4>Add Tickets</h4>
                            <button onClick={handleClose} className='close-btn'>
                                &times;
                            </button>

                        </div>
                        <div className='modal_body'>

                            <Form<PriceCategoryFormValues>
                                id={formName}
                                name={formName}
                                form={form}
                                layout='vertical'
                                initialValues={getInitialValues}
                                onFinish={handleUpdate}
                                // requiredMark={'optional'}
                                onFinishFailed={() => {
                                    setValidateTrigger(['onChange']);
                                }}
                                validateTrigger={validateTrigger}
                                disabled={isLoading}
                            >
                                <div className='frmscrll'>
                                    <AddPriceCategoryForm
                                        editId={editId}
                                        form={form}
                                        selectedSeats={selectedSeats}
                                        setSelectedSeats={setSelectedSeats}
                                        layoutType={layoutType}
                                        filteredSeatArray={filteredSeatArray}
                                        getEventDetaildata={getEventDetaildata}
                                    />
                                </div>

                                {/* <div className='form-button'> */}
                                <Form.Item>
                                    <Button type="primary" htmlType='submit' className="btn" >Save</Button>
                                </Form.Item>

                                {/* </div> */}

                            </Form>

                        </div>
                    </div >
                </>

            }

        </>
    )
};
